export default function About() {
  return (
    <section id="about" className="bg-white py-32 relative overflow-hidden">
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-blue-50/30 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-[1200px] mx-auto px-20">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="w-48 h-px bg-gray-300 mb-8"></div>
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-[0.15em] mb-6">Who We Are</span>
          <h2 className="text-6xl font-bold text-gray-900 mb-12" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Modern intelligence for serious businesses
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-16 mb-16">
          <div className="space-y-8">
            <div className="relative h-[280px] rounded-2xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/de79710dbed86affd2f0a1b0a90ccd89.jpg"
                alt="Professional collaboration"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-lg text-gray-700 leading-relaxed">
              GenieAiX is an AI systems and automation partner for professional service organizations that demand precision, reliability, and discretion.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We work with firms that value structure and reputation—but recognize the need to evolve. Our role is to introduce intelligent systems that enhance how your business operates, without disrupting what already works.
            </p>
          </div>
          <div className="space-y-8">
            <p className="text-lg text-gray-700 leading-relaxed">
              This is not experimental AI. This is applied intelligence.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              We understand the unique challenges of professional services—where reputation, compliance, and client trust are paramount. Our systems are designed to amplify your team's capabilities while maintaining the standards that define your practice.
            </p>
            <div className="relative h-[280px] rounded-2xl overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20AI%20technology%20visualization%20with%20neural%20networks%20and%20data%20streams%20in%20elegant%20professional%20setting%2C%20abstract%20digital%20transformation%20concept%20with%20geometric%20patterns%20and%20flowing%20information%2C%20sophisticated%20navy%20blue%20and%20white%20color%20scheme%2C%20clean%20corporate%20aesthetic%20with%20depth%20and%20dimension&width=600&height=400&seq=about-visual-2&orientation=landscape"
                alt="AI technology"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-2xl text-gray-800 italic" style={{ fontFamily: 'Crimson Pro, serif' }}>
            This is not experimental AI.<br />This is applied intelligence.
          </p>
        </div>
      </div>
    </section>
  );
}
